import { z } from 'zod';

export const currencySchema = z.enum(['SAR', 'USD']);
export type Currency = z.infer<typeof currencySchema>;
